import styled, { css } from 'styled-components';
import { Card } from '../Card';

import { CardActionProps } from './types';

const standardStyle = css`
  box-shadow: ${({ theme }) => theme.mosaiq.elevation[1]};
  border: 1px solid ${({ theme }) => theme.mosaiq.colors.grey60};

  &:hover {
    background-color: ${({ theme }) => theme.mosaiq.colors.grey} !important;
  }

  &:active {
    background-color: ${({ theme }) => theme.mosaiq.colors.grey40} !important;
    border-color: ${({ theme }) => theme.mosaiq.colors.grey40};
  }
`;

const disabledStyle = css`
  border: 1px dashed ${({ theme }) => theme.mosaiq.colors.grey60};
`;

export const CardActionContainer = styled(Card).attrs<CardActionProps>(({ active, theme }) => ({
  borderRadius: 2,
  role: 'button',
  backgroundColor: active ? theme.mosaiq.colors.black : 'transparent',
}))<CardActionProps>`
  box-sizing: border-box;

  ${({ active, disabled, onClick, theme }) => {
    if (!active && !disabled) {
      return onClick
        ? standardStyle
        : css`
            box-shadow: ${theme.mosaiq.elevation[1]};
            border: 1px solid ${theme.mosaiq.colors.grey60};
          `;
    } else if (disabled) {
      return disabledStyle;
    } else return '';
  }}
`;
